'use strict';

exports.__esModule = true;
exports.loaders = exports.dynamicArgumentsMap = undefined;

var _doctifyGlobalRedux = require('doctify-global-redux');

var _doctifyGlobalRedux2 = _interopRequireDefault(_doctifyGlobalRedux);

var _pageActions = require('../actions/page-actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _globalRedux$globalAc = _doctifyGlobalRedux2.default.globalActions.ListingsActions,
    getInsurers = _globalRedux$globalAc.getInsurers,
    getSpecialties = _globalRedux$globalAc.getSpecialties,
    getTreatmentGroups = _globalRedux$globalAc.getTreatmentGroups,
    getProfessionalBodies = _globalRedux$globalAc.getProfessionalBodies,
    getHealthChecks = _globalRedux$globalAc.getHealthChecks;
var dynamicArgumentsMap = exports.dynamicArgumentsMap = {
	_id_: 'params.id'
};

var loaders = exports.loaders = [{
	key: 'listings.insurers',
	action: getInsurers
}, {
	key: 'listings.specialties',
	action: getSpecialties
}, {
	key: 'listings.healthChecksTreatmentGroups',
	action: getTreatmentGroups,
	arguments: ['heath_check']
}, {
	key: 'listings.scansTreatmentGroups',
	action: getTreatmentGroups,
	arguments: ['scan']
}, {
	key: 'listings.professionalBodies',
	action: getProfessionalBodies
}, {
	key: 'listings.healthChecks',
	action: getHealthChecks
}, {
	key: 'loadedUri',
	action: _pageActions.PageActions.loadUri,
	arguments: ['_id_'],
	dynamicArguments: ['_id_']
}, {
	key: 'loadedUri',
	action: _pageActions.PageActions.loadPracticeProfile,
	arguments: ['_id_'],
	dynamicArguments: ['_id_']
}, {
	key: 'loadedUri',
	action: _pageActions.PageActions.loadPracticeReviews,
	arguments: ['_id_'],
	dynamicArguments: ['_id_'],
	loadFrontAndServerSide: true
}];


// WEBPACK FOOTER //
// ./components/practice-page/lib/utils/loaders.js